import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import fallback_image from './../../images/member-fallback.svg';
import {
		DEMOCRATIC,
		DEMOCRATIC_COLOR,
		REPUBLICAN,
		REPUBLICAN_COLOR,
		INDEPENDENT_COLOR,
		IMAGES_ENDPOINT,
		getStateFromAbbreviation
	} from '../../common/Utils';

import StackedImageCard from '../member/StackedImageCard';

const IMAGE_BUCKET_BASE = "https://member-pages.s3.us-east-2.amazonaws.com/";

function getLeadershipPosition(member) {
	if (undefined !== member) {
		if (undefined !== member.leadershipPositions && 1 <= member.leadershipPositions.length ) {
			return member.leadershipPositions[0].title;
		} else if (undefined !== member.positions && 1 <= member.positions.length ){
			return member.positions[0].title;
		} else {
			return " ";
		}
	}
	return " ";
};

function getParty(member) {
	if (undefined !== member && undefined !== member.party) {
		return member.party.label;
	} else {
		return "";
	}
}

function getChamber(member) {
	if (undefined === member
		|| undefined === member.positions
		|| 0 === member.positions.length
		|| undefined === member.positions[0].title) {
		return "";
	} else {
		return (("Senator" === member.positions[0].title)
				?"Senate":"House");
	}
}

function getPartyColor(member) {
	switch (getParty(member)) {
		case DEMOCRATIC:
			return DEMOCRATIC_COLOR;
		case REPUBLICAN:
			return REPUBLICAN_COLOR;
		default:
			return INDEPENDENT_COLOR;
	}
}

function getAbbreviation(member) {
	if (undefined === member
		|| undefined === member.positions
		|| 0 === member.positions.length
		|| undefined === member.positions[0].stateDistrictCode) {
		return;
	} else {
		return member.positions[0].stateDistrictCode.split("-")[0];
	}
}

function getState(member) {
	const abbreviation = getAbbreviation(member);
	if (undefined === abbreviation) {
		return null;
	} else {
		return getStateFromAbbreviation(abbreviation);
	}
}

function getStateIconURL(member) {
	const abbreviation = getAbbreviation(member);
	if (undefined === abbreviation) {
		return null;
	} else {
		return IMAGE_BUCKET_BASE.concat(abbreviation,".svg");
	}
}

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		marginTop: 20,
		border: '1px solid #C8CCD1'
	},
	heroRight: {
		display: 'flex',
  		alignItems: 'center',
  		justifyContent: 'center',
  		width: '100%'
	},
	memberNameText: {
		color: '#333333',
		fontFamily: 'Graphik',
		fontSize: 36,
		fontWeight: 'bold',
		letterSpacing: 0,
		textAlign: 'center',
		lineHeight: 1,
	},
	postionText: {
		color: '#333333',
		fontFamily: 'Graphik',
		fontSize: 22,
		fontWeight: 500,
		letterSpacing: 0,
		marginTop: 20,
		marginBottom: 20,
	},
	media: {
		height: 354,
		maxWidth: '100%'
	},
	content: {
		textAlign: "center",
		width: '100%'
	},
	divider: {
		width: "20%",
		height: 10,
		marginRight: "auto",
		marginLeft: "auto",
		marginBottom: 10
	},
	iconContainer: {
		marginTop: 20,
	},
	iconDivider: {
		color: '#E0E0E',
		width: 1
	}
});

const MemberHeroCard = ( member = {}  ) => {
	const {
		personId,
		fullName,

	} = member;
	const classes = useStyles();

  	const FALLBACK_IMAGE = fallback_image;

	const onMediaFallback = event => event.target.src = FALLBACK_IMAGE;

	if (undefined === member || !Object.keys(member).length) {
    	return null;
	}

	const showState = getStateIconURL(member) && getPartyColor(member)

	return (
		<Card className={classes.root} variant="outlined">
		<Grid container spacing={3}>
			<Grid item xs={12} md={4}>
				<CardMedia
				component="img"
				className={classes.media}
				image={IMAGES_ENDPOINT.concat(personId,"/image/medium")}
				onError={onMediaFallback}
				/>
			</Grid>
			<Grid item xs={12} md={8} className={classes.heroRight}>
				<CardContent className={classes.content}>
				<Typography className={classes.memberNameText}>
					{fullName}
				</Typography>
				<Typography className={classes.postionText}>
					{getLeadershipPosition(member)}
				</Typography>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Grid container justify="center" spacing={2}>
							<Grid xs={3} key="Party" item>
								<StackedImageCard
									imageURL={"https://member-pages.s3.us-east-2.amazonaws.com/icon-".concat(getParty(member).toLowerCase(),".svg")}
									imageColor={getPartyColor(member)}
									title="Party"
									value={getParty(member)} />
							</Grid>
							<Grid key="Divider1" item>
								<Divider className={classes.iconDivider} orientation="vertical" />
							</Grid>
							<Grid xs={3} key="Chamber" item>
								<StackedImageCard
									imageURL="https://member-pages.s3.us-east-2.amazonaws.com/icon-chamber.svg"
									imageColor={getPartyColor(member)}
									title="Chamber"
									value={getChamber(member)} />
							</Grid>
							{showState ?
								<>
								<Grid key="Divider2" item>
									<Divider className={classes.iconDivider} orientation="vertical" />
								</Grid>
								<Grid xs={3} key="State" item>
									<StackedImageCard
										imageURL={getStateIconURL(member)}
										imageColor={getPartyColor(member)}
										title="State"
										value={getState(member)} />
								</Grid>
								</>
							:''}

						</Grid>
					</Grid>
				</Grid>
				</CardContent>
			</Grid>
		</Grid>
		</Card>
	);
};

export default MemberHeroCard;
